module.exports = __webpack_public_path__ + "img/news3-2.a6864756.jpeg";